// Vendor Libs
import React from 'react';

// Components
import DisplayPathForm from './display-path-form';
import Permissions from '../core/permissions';

// Containers
import FormData from '../../containers/form-data';

const formName = 'createDisplayPath';

function CreateDisplayPath() {
    return (
        <Permissions
            accessRequirement="create"
            elementService="networkDisplayPath"
            notAuthorizedMessage={true}
            requiresServiceAccess={true}
        >
            <FormData formName={formName}>
                {({ setFieldValue, resetForm }) => (
                    <DisplayPathForm
                        className="create-display-path"
                        formName={formName}
                        setFieldValue={setFieldValue}
                        onReset={resetForm}
                    />
                )}
            </FormData>
        </Permissions>
    );
}

export default CreateDisplayPath;
